const urlKey = 'previousLoginURL';

/**
 * This hook saves the URL pasted in the address bar before logging in
 * and after the user is logged in, it navigates there automagically
 * for quality of life
 */
export function useURLPriorToLogin() {
  const saveURLPriorToLogin = () => {
    const {location} = window;
    // if on the redirect login (aka starts with /?code=) then dont save url
    if (location.pathname.startsWith('/?') || location.search.startsWith('?code')) {
      return;
    }
    window.sessionStorage.setItem(urlKey, location.pathname + location.search);
  };

  return {saveURLPriorToLogin};
}

export const getURLPriorToLogin = () => {
  const previousURL = window.sessionStorage.getItem(urlKey);

  if (!previousURL || window.location.href === previousURL) {
    return;
  }
  return previousURL;
};
